import React, { useState, useEffect, useMemo, useRef } from "react";
import Tooltip from "@mui/material/Tooltip";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import "react-datepicker/dist/react-datepicker.css";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import moment from "moment-timezone";
import FunctionsIcon from "@mui/icons-material/Functions";
import ReactApexChart from "react-apexcharts";
import { Grid, IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  getAmenazasVulnerabilidadesRangos,
  getTablaAmenazasVulnerabilidades,
} from "../services/amenazas/amenazasVulnerabilidades/amenazasVulnerabilidadesData";
import { useNavigate } from "react-router-dom";
import SeleccionarActivo from "./CalculoRiesgo/SeleccionarActivo";
import TablaAmenaza from "./CalculoRiesgo/TablaAmenaza";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useAuth } from "../context/AuthContext";

export const Riesgo = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const empresaNombre =
    user?.emp_nombre || user?.empresa || user?.nombre_empresa || "EvalTrack";
  const [calculoRealizado, setCalculoRealizado] = useState(false);
  const [lista2, setLista2] = useState([]);
  const [resetKey, setResetKey] = useState(0);
  const steps = [
    "Seleccionar Activos",
    "Visualización",
    "Cálculo de Probabilidad",
  ];

  const [selectedIds, setSelectedIds] = useState([]);
  const [selectedDates, setSelectedDates] = useState([]);
  const [rows, setRows] = useState([]);

  const handleActualizacion = (filasActualizadas) => {
    setRows(filasActualizadas);
  };

  function getStepContent(step) {
    switch (step) {
      case 0:
        return (
          <SeleccionarActivo
            key={resetKey}
            onRowsUpdate={handleActualizacion}
            setSelectedIds={setSelectedIds}
            setSelectedDates={setSelectedDates}
            lista2={lista2}
            setLista2={setLista2}
          />
        );
      case 1:
        return (
          <TablaAmenaza
            selectedIds={selectedIds}
            selectedDates={selectedDates}
          />
        );
      case 2:
        return (
          <TablaResultado
            selectedIds={selectedIds}
            selectedDates={selectedDates}
          />
        );
      default:
        throw new Error("Unknown step");
    }
  }

  const TablaResultado = ({ selectedIds, selectedDates }) => {
    const [tablaFinal, setTablaFinal] = useState([]);
    const [heatmapSeries, setHeatmapSeries] = useState([]);
    const [heatmapOptions, setHeatmapOptions] = useState({});
    const [riesgoData, setRiesgoData] = useState([]);
    const [autoCalcPending, setAutoCalcPending] = useState(false);
    const chartRef = useRef(null);

    const riesgoOrder = [
      "Despreciable",
      "Bajo",
      "Medio",
      "Alto",
      "Muy Alto",
      "Daño Extremo",
    ];

    const normalizarFrecuencia = (frecuencia = "") => {
      const mapeo = {
        "Muy Baja": "MB",
        "Baja": "B",
        "Media": "M",
        "Alta": "A",
        "Muy Alta": "MA",
        MB: "MB",
        B: "B",
        M: "M",
        A: "A",
        MA: "MA",
      };
      return mapeo[frecuencia] || frecuencia;
    };

    const obtenerEtiquetaFrecuencia = (frecuencia = "") => {
      const mapeo = {
        MB: "Muy Baja",
        B: "Baja",
        M: "Media",
        A: "Alta",
        MA: "Muy Alta",
      };
      return mapeo[frecuencia] || frecuencia;
    };

    const convertirRiesgoNumericoATexto = (numero) => {
      const mapeo = {
        0: "Despreciable",
        1: "Bajo",
        2: "Bajo",
        3: "Bajo",
        4: "Medio",
        5: "Medio",
        7: "Alto",
        8: "Alto",
        9: "Muy Alto",
        10: "Muy Alto",
      };
      return mapeo[numero] || "Despreciable";
    };

    const generarTablaDefault = () => {
      const tabla = {
        MB: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        B: [0, 1, 2, 3, 5, 5, 5, 7, 7, 7, 7],
        M: [0, 1, 2, 3, 5, 5, 5, 7, 8, 8, 8],
        A: [0, 1, 2, 3, 5, 5, 7, 8, 9, 9, 10],
        MA: [1, 1, 4, 4, 5, 5, 9, 9, 9, 10, 10],
      };

      const resultado = [];
      Object.keys(tabla).forEach((freq) => {
        tabla[freq].forEach((riesgo, impacto) => {
          resultado.push({
            VAL_IMPACTO: impacto,
            VA_FRECUENCIA: freq,
            VA_IMPACTO: convertirRiesgoNumericoATexto(riesgo),
            VAL_RIESGO: riesgo,
          });
        });
      });
      return resultado;
    };

    const sortedTablaFinal = [...tablaFinal].sort(
      (a, b) => riesgoOrder.indexOf(a.riesgo) - riesgoOrder.indexOf(b.riesgo)
    );

    const cellMap = {};
    sortedTablaFinal.forEach((row) => {
      const freqKey = ["MB", "B", "M", "A", "MA"].find(
        (f) =>
          row.frecuencia1 === f ||
          row.frecuencia1 ===
          (f === "MB"
            ? "Muy Baja"
            : f === "B"
              ? "Baja"
              : f === "M"
                ? "Media"
                : f === "A"
                  ? "Alta"
                  : f === "MA"
                    ? "Muy Alta"
                    : f)
      );
      if (!cellMap[freqKey]) cellMap[freqKey] = {};
      if (!cellMap[freqKey][row.promedio]) cellMap[freqKey][row.promedio] = [];
      cellMap[freqKey][row.promedio].push({
        amenazaId: row.amenazaId,
        amenaza: row.amenaza,
      });
    });

    useEffect(() => {
      async function fetchData() {
        try {
          const responses = [];

          for (let i = 0; i < selectedIds.length; i++) {
            const currentId = selectedIds[i];
            let currentDate = selectedDates[i];

            if (!currentDate) continue;

            currentDate = moment(currentDate).format("YYYY-MM-DD");

            try {
              const activoVulnerabilidadData =
                await getTablaAmenazasVulnerabilidades(currentId, currentDate);

              if (!Array.isArray(activoVulnerabilidadData)) continue;

              const mappedData = activoVulnerabilidadData.map((item) => ({
                amenaza: item.ame_nombre,
                vulnerabilidad: item.vul_nombre,
                promedio: Number(item.promedio_grupo),
                costo: Number(item.vac_costo),
                frecuencia1: item.amv_probabilidad,
                riesgo: "",
                riesgoNumerico: 0,
              }));

              responses.push(mappedData);
            } catch (error) {
              console.error(error);
            }
          }

          const combinedData = responses.flat();

          const frecuenciaOrder = {
            "Muy Baja": 1,
            Baja: 2,
            Media: 3,
            Alta: 4,
            "Muy Alta": 5,
          };

          const groupedByThreatAndVuln = combinedData.reduce((acc, item) => {
            const key = `${item.amenaza}|${item.vulnerabilidad}`;
            if (!acc[key]) {
              acc[key] = {
                amenaza: item.amenaza,
                vulnerabilidad: item.vul_nombre,
                promedios: [item.promedio],
                costos: [item.costo],
                frecuencia1: item.frecuencia1,
              };
            } else {
              acc[key].promedios.push(item.promedio);
              acc[key].costos.push(item.costo);
              acc[key].frecuencia1 =
                frecuenciaOrder[item.frecuencia1] >
                  frecuenciaOrder[acc[key].frecuencia1]
                  ? item.frecuencia1
                  : acc[key].frecuencia1;
            }
            return acc;
          }, {});

          const consolidatedByThreatAndVuln = Object.values(
            groupedByThreatAndVuln
          ).map((group) => {
            const promedioMedia = Number(
              (
                group.promedios.reduce((acc, val) => acc + val, 0) /
                group.promedios.length
              ).toFixed(2)
            );
            const costoTotal = group.costos.reduce((acc, val) => acc + val, 0);
            return {
              amenaza: group.amenaza,
              vulnerabilidad: group.vul_nombre,
              promedio: promedioMedia,
              costo: costoTotal,
              frecuencia1: group.frecuencia1,
            };
          });

          const groupedByThreat = consolidatedByThreatAndVuln.reduce(
            (acc, item) => {
              const key = item.amenaza;
              if (!acc[key]) {
                acc[key] = {
                  amenaza: item.amenaza,
                  promedios: [item.promedio],
                  costos: [item.costo],
                  frecuencias: [item.frecuencia1],
                };
              } else {
                acc[key].promedios.push(item.promedio);
                acc[key].costos.push(item.costo);
                acc[key].frecuencias.push(item.frecuencia1);
              }
              return acc;
            },
            {}
          );

          const calculatedData = Object.values(groupedByThreat).map((group) => {
            const promedioMedia = Math.round(
              group.promedios.reduce((acc, val) => acc + val, 0) /
              group.promedios.length
            );
            const costoTotal = group.costos.reduce((acc, val) => acc + val, 0);
            const frecuenciaMasAlta = group.frecuencias.reduce((max, curr) => {
              return frecuenciaOrder[curr] > frecuenciaOrder[max] ? curr : max;
            }, group.frecuencias[0]);
            return {
              amenaza: group.amenaza,
              frecuencia1: frecuenciaMasAlta,
              promedio: promedioMedia,
              costo: costoTotal,
              riesgo: "",
              riesgoNumerico: 0,
            };
          });

          const calculatedDataWithIds = calculatedData.map((item, idx) => ({
            ...item,
            amenazaId: `A${idx + 1}`,
          }));

          setTablaFinal(calculatedDataWithIds);
          setAutoCalcPending(true);

          try {
            const riesgoData = await getAmenazasVulnerabilidadesRangos();
            if (!riesgoData || riesgoData.length === 0) {
              const tablaDefault = generarTablaDefault();
              setRiesgoData(tablaDefault);
            } else {
              const riesgoMapeado = riesgoData
                .map((item) => ({
                  VAL_IMPACTO: Number(item.VAL_IMPACTO),
                  VA_FRECUENCIA: normalizarFrecuencia(item.VA_FRECUENCIA || ""),
                  VA_IMPACTO: item.VA_IMPACTO,
                  VAL_RIESGO: Number(item.VAL_RIESGO),
                }))
                .filter(
                  (item) =>
                    !Number.isNaN(item.VAL_IMPACTO) &&
                    item.VA_FRECUENCIA &&
                    !Number.isNaN(item.VAL_RIESGO)
                );
              setRiesgoData(riesgoMapeado);
            }
          } catch (error) {
            const tablaDefault = generarTablaDefault();
            setRiesgoData(tablaDefault);
          }
        } catch (error) {
          console.error("Error general:", error);
        }
      }

      fetchData();
    }, [selectedIds, selectedDates]);

    const handleCalculoAutomatico = () => {
      setAutoCalcPending(false);
      if (!riesgoData || riesgoData.length === 0) return;

      setTablaFinal((prevTablaFinal) => {
        const updatedTablaFinal = prevTablaFinal.map((row) => {
          const promedio = row.promedio;
          const frecuencia = row.frecuencia1;
          const frecuenciaNormalizada = normalizarFrecuencia(frecuencia);

          const exactMatch = riesgoData.find(
            (data) =>
              data.VA_FRECUENCIA === frecuenciaNormalizada &&
              data.VAL_IMPACTO === promedio
          );

          if (exactMatch) {
            const etiqueta = obtenerEtiquetaFrecuencia(exactMatch.VA_FRECUENCIA);
            return {
              ...row,
              frecuencia: exactMatch.VA_FRECUENCIA,
              frecuencia1: etiqueta || row.frecuencia1,
              riesgo: exactMatch.VA_IMPACTO,
              riesgoNumerico: exactMatch.VAL_RIESGO,
            };
          }

          const datosConFrecuencia = riesgoData.filter(
            (data) => data.VA_FRECUENCIA === frecuenciaNormalizada
          );

          if (datosConFrecuencia.length > 0) {
            const promedioAjustado = Math.min(promedio, 10);

            const closestMatchingDataList = datosConFrecuencia
              .map((data) => {
                const diffPromedio = Math.abs(data.VAL_IMPACTO - promedioAjustado);
                return { data, distance: diffPromedio };
              })
              .sort((a, b) => a.distance - b.distance);

            if (closestMatchingDataList.length > 0) {
              const closestMatchingData = closestMatchingDataList[0];
              const etiqueta = obtenerEtiquetaFrecuencia(closestMatchingData.data.VA_FRECUENCIA);
              return {
                ...row,
                frecuencia: closestMatchingData.data.VA_FRECUENCIA,
                frecuencia1: etiqueta || row.frecuencia1,
                riesgo: closestMatchingData.data.VA_IMPACTO,
                riesgoNumerico: closestMatchingData.data.VAL_RIESGO,
              };
            }
          }

          const fallbackValor = getValorRiesgoTabla(Math.min(promedio, 10), frecuenciaNormalizada);
          return {
            ...row,
            frecuencia: frecuenciaNormalizada,
            frecuencia1: obtenerEtiquetaFrecuencia(frecuenciaNormalizada) || row.frecuencia1,
            riesgo: convertirRiesgoNumericoATexto(fallbackValor),
            riesgoNumerico: fallbackValor,
          };
        });
        setCalculoRealizado(true);
        return updatedTablaFinal;
      });
    };

    useEffect(() => {
      if (!autoCalcPending) return;
      if (tablaFinal.length === 0 || riesgoData.length === 0) return;
      handleCalculoAutomatico();
      setAutoCalcPending(false);
    }, [autoCalcPending, tablaFinal, riesgoData]);

    const getTextColor = (riesgo) => {
      switch (riesgo) {
        case "Despreciable": return "gray";
        case "Bajo": return "green";
        case "Medio": return "#FFC133";
        case "Alto": return "orange";
        case "Muy Alto": return "red";
        case "Daño Extremo": return "red";
        default: return "inherit";
      }
    };

    const impactos = useMemo(() => [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10], []);
    const frecuencias = useMemo(() => ["MB", "B", "M", "A", "MA"], []);

    function getValorRiesgoTabla(im, fr) {
      if (riesgoData && riesgoData.length > 0) {
        const match = riesgoData.find(
          (item) => item.VAL_IMPACTO === im && item.VA_FRECUENCIA === fr
        );
        if (match) return match.VAL_RIESGO;
      }

      const tabla = {
        MB: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        B: [0, 1, 2, 3, 5, 5, 5, 7, 7, 7, 7],
        M: [0, 1, 2, 3, 5, 5, 5, 7, 8, 8, 8],
        A: [0, 1, 2, 3, 5, 5, 7, 8, 9, 9, 10],
        MA: [1, 1, 4, 4, 5, 5, 9, 9, 9, 10, 10],
      };
      return tabla[fr] ? tabla[fr][im] : 0;
    }

    useEffect(() => {
      const series = frecuencias.map((freq) => ({
        name: freq,
        data: impactos.map((imp) => {
          const amenazas = cellMap[freq]?.[imp] || [];
          return {
            x: imp,
            y: getValorRiesgoTabla(imp, freq),
            isSelected: amenazas.length > 0,
            amenazas,
          };
        }),
      }));

      const options = {
        chart: {
          type: "heatmap",
          height: 300, // Reduced height
          toolbar: { show: false },
        },
        dataLabels: {
          enabled: true,
          style: {
            colors: ["#000"],
            fontWeight: "bold",
            fontSize: "14px", // Reduced font size
          },
          formatter: function (val, { seriesIndex, dataPointIndex, w }) {
            const cell = w.config.series[seriesIndex].data[dataPointIndex];
            if (cell && cell.isSelected && cell.amenazas.length > 0) {
              const ids = cell.amenazas.map((a) => a.amenazaId);
              const joined = ids.join(", ");
              if (joined.length > 10) return joined.slice(0, 10) + '...';
              return joined;
            }
            return val !== null && val !== undefined ? val : "";
          },
        },
        tooltip: {
          enabled: true,
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {
            const cell = w.config.series[seriesIndex].data[dataPointIndex];
            if (cell && cell.isSelected && cell.amenazas.length > 0) {
              return `<div style="padding:8px"><b>Amenazas:</b><br/>${cell.amenazas
                .map((a) => `<b>${a.amenazaId}:</b> ${a.amenaza}`)
                .join("<br/>")}</div>`;
            }
            return "";
          },
        },
        plotOptions: {
          heatmap: {
            colorScale: {
              ranges: [
                { from: 0, to: 3, color: "#A8E063", name: "Bajo" },
                { from: 4, to: 6, color: "#FFFF00", name: "Medio" },
                { from: 7, to: 8, color: "#FFA500", name: "Alto" },
                { from: 9, to: 10, color: "#FF0000", name: "Muy Alto" },
              ],
            },
          },
        },
        fill: {
          opacity: function ({ seriesIndex, dataPointIndex, w }) {
            const cell = w.config.series[seriesIndex].data[dataPointIndex];
            if (!calculoRealizado) return 0.5;
            if (cell && cell.isSelected && cell.amenazas.length > 0) return 1;
            return 0.5;
          },
        },
        xaxis: {
          type: "category",
          categories: impactos,
          title: { text: "Impacto" },
        },
        yaxis: {
          categories: frecuencias,
          title: { text: "Frecuencia" },
        },
        title: {
          text: "Tabla de Valoración del Riesgo",
          align: 'center',
          style: { color: '#001F3F', fontSize: '16px' }
        },
      };

      setHeatmapSeries(series);
      setHeatmapOptions(options);
    }, [tablaFinal, impactos, frecuencias, calculoRealizado]);

    const handleExportPdf = async () => {
      if (!tablaFinal || tablaFinal.length === 0) {
        return;
      }

      const doc = new jsPDF("landscape");
      const marginX = 14;

      doc.setFontSize(14);
      doc.setTextColor("#001F3F");
      doc.text("RAC-001 - Reporte de Cálculo de Riesgo", marginX, 18);

      doc.setFontSize(10);
      doc.setTextColor("#6B7280");
      doc.text(
        `Empresa: ${empresaNombre || "No especificada"}`,
        marginX,
        24
      );
      doc.text(
        `Generado el ${moment().format("YYYY-MM-DD HH:mm")}`,
        marginX,
        30
      );

      // Tabla de resumen
      const resumen = sortedTablaFinal.map((row) => ({
        Amenaza: `${row.amenazaId} - ${row.amenaza}`,
        Impacto: row.promedio,
        Costo: row.costo,
        Frecuencia: row.frecuencia1,
        Riesgo: row.riesgo,
        "Valor Riesgo": row.riesgoNumerico,
      }));

      autoTable(doc, {
        startY: 36,
        head: [["Amenaza", "Impacto", "Costo", "Frecuencia", "Riesgo", "Valor Riesgo"]],
        body: resumen.map((r) => Object.values(r)),
        styles: { fontSize: 8 },
        headStyles: { fillColor: [0, 31, 63] },
      });

      let currentY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 8 : 44;

      // Tabla de escala de valoración del riesgo
      const escala = [
        { nivel: "Despreciable", rango: "0", descripcion: "Riesgo prácticamente nulo" },
        { nivel: "Bajo", rango: "1 - 3", descripcion: "Riesgo controlado o aceptable" },
        { nivel: "Medio", rango: "4 - 6", descripcion: "Riesgo moderado que requiere seguimiento" },
        { nivel: "Alto", rango: "7 - 8", descripcion: "Riesgo significativo que requiere acciones" },
        { nivel: "Muy Alto / Daño Extremo", rango: "9 - 10", descripcion: "Riesgo crítico que exige tratamiento inmediato" },
      ];

      doc.setFontSize(11);
      doc.setTextColor("#001F3F");
      doc.text("Escala de Valoración del Riesgo", marginX, currentY);

      autoTable(doc, {
        startY: currentY + 4,
        head: [["Nivel", "Rango numérico", "Descripción"]],
        body: escala.map((e) => [e.nivel, e.rango, e.descripcion]),
        styles: { fontSize: 8 },
        headStyles: { fillColor: [241, 245, 249], textColor: 0 },
      });

      currentY = doc.lastAutoTable ? doc.lastAutoTable.finalY + 8 : currentY + 24;

      // Recomendaciones generales basadas en los riesgos más altos
      const topRiesgos = [...sortedTablaFinal]
        .filter((r) => r.riesgoNumerico !== undefined && r.riesgoNumerico !== null)
        .sort((a, b) => b.riesgoNumerico - a.riesgoNumerico)
        .slice(0, 3);

      if (topRiesgos.length > 0) {
        doc.setFontSize(11);
        doc.setTextColor("#001F3F");
        doc.text("Resumen de riesgos prioritarios", marginX, currentY);

        doc.setFontSize(9);
        doc.setTextColor("#111827");

        let y = currentY + 5;
        topRiesgos.forEach((r, index) => {
          const linea = `${index + 1}. ${r.amenazaId} - ${r.amenaza}: nivel ${r.riesgo} (valor ${r.riesgoNumerico}), frecuencia ${r.frecuencia1}, impacto ${r.promedio}, costo estimado ${r.costo}.`;
          doc.text(linea, marginX, y);
          y += 5;
        });

        y += 3;
        doc.setFontSize(8);
        doc.setTextColor("#6B7280");
        doc.text(
          "Sugerencia: revise y priorice contramedidas en el módulo de Contramedidas para los riesgos anteriores.",
          marginX,
          y
        );

        currentY = y + 8;
      }

      // Imagen del heatmap
      const finalY = currentY;
      try {
        if (chartRef.current && chartRef.current.chart) {
          const dataURI = await chartRef.current.chart.dataURI();
          const imgProps = doc.getImageProperties(dataURI.imgURI);
          const imgWidth = 120;
          const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
          doc.addImage(
            dataURI.imgURI,
            "PNG",
            marginX,
            finalY,
            imgWidth,
            imgHeight
          );
        }
      } catch (e) {
        // Si falla la imagen, igual dejamos el PDF con la tabla
      }

      doc.save("RAC-001.pdf");
    };

    return (
      <Grid container spacing={2}>
        <Grid item xs={12} container justifyContent="flex-end">
          <Button
            variant="contained"
            startIcon={<FunctionsIcon />}
            onClick={handleCalculoAutomatico}
            size="small"
            sx={{
              mt: 1,
              backgroundColor: '#001F3F',
              color: '#fff',
              '&:hover': { backgroundColor: '#003366' },
              textTransform: 'none',
              fontWeight: 500
            }}
          >
            Realizar Cálculo
          </Button>
        </Grid>
        <Grid item xs={12}>
          <TableContainer component={Paper} elevation={1} sx={{ borderRadius: 2 }}>
            <Table size="small">
              <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
                <TableRow>
                  <TableCell align="center" sx={{ color: '#001F3F', fontWeight: 600, fontSize: '0.85rem' }}>Amenaza</TableCell>
                  <TableCell align="center" sx={{ color: '#001F3F', fontWeight: 600, fontSize: '0.85rem' }}>Impacto</TableCell>
                  <TableCell align="center" sx={{ color: '#001F3F', fontWeight: 600, fontSize: '0.85rem' }}>Costo</TableCell>
                  <TableCell align="center" sx={{ color: '#001F3F', fontWeight: 600, fontSize: '0.85rem' }}>Frecuencia</TableCell>
                  <TableCell align="center" sx={{ color: '#001F3F', fontWeight: 600, fontSize: '0.85rem' }}>Riesgo</TableCell>
                  <TableCell align="center" sx={{ color: '#001F3F', fontWeight: 600, fontSize: '0.85rem' }}>Valor del Riesgo</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortedTablaFinal.map((row, rowIndex) => (
                  <TableRow key={rowIndex} hover>
                    <TableCell sx={{ fontSize: '0.85rem' }}>
                      <Tooltip title={row.amenaza} arrow>
                        <span>{row.amenazaId} - {row.amenaza}</span>
                      </Tooltip>
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: '0.85rem' }}>{row.promedio}</TableCell>
                    <TableCell align="center" sx={{ fontSize: '0.85rem' }}>${row.costo}</TableCell>
                    <TableCell align="center" sx={{ fontSize: '0.85rem' }}>{row.frecuencia1}</TableCell>
                    <TableCell align="center" sx={{ fontSize: '0.85rem' }}>
                      <b style={{ color: getTextColor(row.riesgo) }}>
                        {row.riesgo}
                      </b>
                    </TableCell>
                    <TableCell align="center" sx={{ fontSize: '0.85rem' }}>
                      <b style={{ color: getTextColor(row.riesgo) }}>
                        {row.riesgoNumerico}
                      </b>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
        <Grid item xs={12}>
          <Paper elevation={1} sx={{ p: 2, borderRadius: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mb: 1,
              }}
            >
              <Typography variant="subtitle1" fontWeight="bold" sx={{ color: '#001F3F' }}>
                Mapa de Calor del Riesgo
              </Typography>
              <Button
                variant="outlined"
                size="small"
                onClick={handleExportPdf}
                sx={{
                  textTransform: "none",
                  borderColor: "#001F3F",
                  color: "#001F3F",
                  "&:hover": { borderColor: "#003366", color: "#003366" },
                }}
              >
                Exportar PDF
              </Button>
            </Box>
            <ReactApexChart
              ref={chartRef}
              options={heatmapOptions}
              series={heatmapSeries}
              type="heatmap"
              height={300}
            />
          </Paper>
        </Grid>
      </Grid>
    );
  };

  const refrescarPagina = () => {
    navigate("/gestionar/Calculo-Riesgo");
  };

  const [activeStep, setActiveStep] = useState(0);

  const handleNext = () => {
    setActiveStep(activeStep + 1);
    if (activeStep === steps.length - 1) {
      setRows(selectedIds);
      setRows(selectedDates);
    }
    if (activeStep === steps.length - 2) {
      setRows(selectedIds);
      setRows(selectedDates);
    }
  };

  const handleBack = () => {
    setActiveStep(activeStep - 1);
    if (activeStep === 1) {
      setSelectedIds([]);
      setSelectedDates([]);
      setLista2([]);
      setResetKey((prev) => prev + 1);
    }
    if (activeStep === steps.length - 2) {
      refrescarPagina();
    }
  };

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Paper
        elevation={2}
        sx={{
          p: 3,
          borderRadius: 2,
          backgroundColor: '#ffffff',
          border: '1px solid #e5e7eb',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: { xs: 'flex-start', sm: 'center' },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: 1,
            mb: 2,
          }}
        >
          <Box>
            <Typography variant="h5" sx={{ fontWeight: 600, color: '#001F3F' }}>
              Cálculo de Riesgo
            </Typography>
            <Typography variant="body2" sx={{ color: '#6b7280', mt: 0.5 }}>
              Sigue los pasos para seleccionar activos, visualizar amenazas y obtener la valoración de riesgo.
            </Typography>
          </Box>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={() => navigate(-1)}
            sx={{
              color: '#001F3F',
              textTransform: 'none',
              fontWeight: 500,
            }}
            size="small"
          >
            Volver
          </Button>
        </Box>

        <Box
          sx={{
            mb: 3,
            p: 2,
            borderRadius: 2,
            backgroundColor: '#f9fafb',
          }}
        >
          <Stepper activeStep={activeStep} alternativeLabel>
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel
                  sx={{
                    '& .MuiStepLabel-label': {
                      fontSize: '0.85rem',
                    },
                  }}
                >
                  {label}
                </StepLabel>
              </Step>
            ))}
          </Stepper>
        </Box>

        {activeStep === steps.length ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <Typography variant="h6" gutterBottom sx={{ color: '#001F3F', fontWeight: 500 }}>
              Proceso completado
            </Typography>
            <Typography variant="body2" sx={{ color: '#6b7280' }}>
              Gracias por usar el sistema IESS para la valoración de riesgos.
            </Typography>
          </Box>
        ) : (
          <React.Fragment>
            <Box sx={{ minHeight: '50vh' }}>{getStepContent(activeStep)}</Box>
            <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 3 }}>
              {activeStep !== 0 && (
                <Button
                  onClick={handleBack}
                  sx={{ mr: 1, color: '#475569', textTransform: 'none' }}
                  size="small"
                >
                  Regresar
                </Button>
              )}
              {activeStep !== steps.length - 1 && (
                <Button
                  variant="contained"
                  onClick={handleNext}
                  disabled={
                    activeStep === steps.length - 1 ||
                    (activeStep === 0 && lista2.length === 0)
                  }
                  size="small"
                  sx={{
                    backgroundColor: '#001F3F',
                    color: '#fff',
                    '&:hover': { backgroundColor: '#003366' },
                    textTransform: 'none',
                    fontWeight: 500,
                  }}
                >
                  {activeStep === steps.length - 2 ? "Confirmar" : "Siguiente"}
                </Button>
              )}
            </Box>
          </React.Fragment>
        )}
      </Paper>
    </Container>
  );
};
